import { memo } from "react";
import {
  Circle as _Circle,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg viewBox="0 0 256 256" {...otherProps} height={size} width={size}>
    <_Rect width="256" height="256" fill="none" />
    <_Circle
      cx="128"
      cy="128"
      r="44"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="24"
    />
    <_Path
      d="M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="24"
    />
  </_Svg>;
};
Icon.displayName = "GearSixBold";
const GearSixBold = memo(themed(Icon));
export {
  GearSixBold
};
//# sourceMappingURL=gear-six-bold.js.map
